<template>
  <div
    :id="id"
    class="properties-field"
  >
    <div class="wrap-properties">
      <!-- Configuration Title -->
      <div class="properties-field-title">
        <h4 class="title">
          Properties
          <div class="title-badge">Sheet</div>
        </h4>
        <div
          class="close-properties"
          @click="closeConfiguration"
        >
          &times;
        </div>
      </div>

      <!-- Configuration Content -->
      <div class="properties-field-content properties-field-content-config">
        <div class="section-field input-field">
          <!-- Sheet Name -->
          <b-form :class="{'error-input' : $v.dataSetup.sheet_name.$error}">
            <label> Sheet Name </label>
            <j-input
              v-model="dataSetup.sheet_name"
              placeholder="Enter sheet name"
            />
          </b-form>

          <!-- Column Source -->
          <b-form
            v-if="!firstSheet"
            :class="{'error-input' : $v.dataSetup.column_source.$error}"
          >
            <label> Column Source </label>
            <j-single-select
              v-model="dataSetup.column_source"
              :options="variableCustomColumns"
              :placeholder="'Select Column Source'"
              label="label"
            />
          </b-form>
        </div>

        <!-- Main Column -->
        <div class="section-field input-field">
          <div
            :class="{'error-input' : $v.dataSetup.main_columns.$error}"
            class="configuration-section"
          >
            <h4 class="configuration-section-title mb-2">
              {{ firstSheet ? 'Column' : 'Main Column' }}
            </h4>

            <!-- Column Block -->
            <draggable
              v-model="dataSetup.main_columns"
              :options="{
                animation:300,
                handle:'.icon-drag'
              }"
              class="d-flex flex-wrap"
            >
              <div
                v-for="(data, index) in dataSetup.main_columns"
                :key="index"
                :class="{'selected': index === selectedIndexColumn}"
                class="field-list py-2"
              >
                <div class="d-flex align-items-center">
                  <img
                    src="@/assets/new-form-ui/dragged.svg"
                    class="icon-drag"
                  >
                  <div class="field-preview">
                    <div class="input-preview column-preview">
                      <img
                        :src="require(`@/assets/icon/column-type/${setIconType(data.type)}.svg`)"
                        :alt="`${data.name}-block`"
                      >
                      <div class="separator" />
                      <div class="column-name">
                        {{ data.name }}
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Edit or Delete -->
                <div class="edit-or-delete">
                  <div class="button">
                    <!-- Edit -->
                    <div
                      class="edit"
                      @click="openConfigColumn(data, index, false)"
                    >
                      <i class="fa fa-pencil-square-o" />
                    </div>
                    <!-- Delete -->
                    <div
                      class="delete"
                      @click="deleteColumn(index, false)"
                    >
                      <i class="fa fa-trash" />
                    </div>
                  </div>
                </div>
              </div>
            </draggable>

            <div
              class="btn-add-config"
              @click="openConfigColumn(null, null, false)"
            >
              + Add Column
            </div>
          </div>
        </div>

        <!-- Custom Class Column -->
        <div
          v-if="!firstSheet"
          class="section-field input-field"
        >
          <div
            :class="{'error-input' : $v.dataSetup.custom_class_columns.$error}"
            class="configuration-section"
          >
            <h4 class="configuration-section-title mb-2">
              Custom Class Column
            </h4>

            <!-- Column Block -->
            <draggable
              v-model="dataSetup.custom_class_columns"
              :options="{
                animation:300,
                handle:'.icon-drag'
              }"
              class="d-flex flex-wrap"
            >
              <div
                v-for="(data, index) in dataSetup.custom_class_columns"
                :key="index"
                :class="{'selected': index === selectedIndexColumn}"
                class="field-list py-2"
              >
                <div class="d-flex align-items-center">
                  <img
                    src="@/assets/new-form-ui/dragged.svg"
                    class="icon-drag"
                  >
                  <div class="field-preview">
                    <div class="input-preview column-preview">
                      <img
                        :src="require(`@/assets/icon/column-type/${setIconType(data.type)}.svg`)"
                        :alt="`${data.name}-block`"
                      >
                      <div class="separator" />
                      <div class="column-name">
                        {{ data.name }}
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Edit or Delete -->
                <div class="edit-or-delete">
                  <div class="button">
                    <!-- Edit -->
                    <div
                      class="edit"
                      @click="openConfigColumn(data, index, true)"
                    >
                      <i class="fa fa-pencil-square-o" />
                    </div>
                    <!-- Delete -->
                    <div
                      class="delete"
                      @click="deleteColumn(index, true)"
                    >
                      <i class="fa fa-trash" />
                    </div>
                  </div>
                </div>
              </div>
            </draggable>

            <div
              class="btn-add-config"
              @click="openConfigColumn(null, null, true)"
            >
              + Add Column
            </div>
          </div>
        </div>
      </div>

      <!-- Button Properties -->
      <div
        :class="{ 'justify-content-end': !fieldDetail }"
        class="properties-field-button"
      >
        <button
          v-if="fieldDetail"
          class="button-border"
          @click="deleteSheet"
        >
          <i class="fa fa-trash" /> Delete
        </button>

        <div class="d-flex align-items-center">
          <button
            class="button-border mr-2"
            @click="closeConfiguration"
          >
            Close
          </button>

          <button
            class="button-blue"
            @click="submitForm"
          >
            {{ fieldDetail ? 'Update' : 'Add' }}
          </button>
        </div>
      </div>
    </div>

    <!-- Configuration Column -->
    <column-configuration
      v-if="isOpenConfigColumn"
      :id="idConfigColumn"
      :field-detail="selectedColumn"
      :select-variable="listVariable"
      :use-additional-format="true"
      :use-filter="firstSheet ? true : false"
      :is-group="true"
      :is-dataset-source="isDatasetSource"
      type="export"
      @delete-configuration="deleteColumn"
      @close-configuration="toggleConfigurationColumn(false)"
      @submit-configuration="submitColumn"
    />
  </div>
</template>

<script>
/* eslint-disable max-len, no-unused-vars, no-nested-ternary, no-console */
import { mapState } from 'vuex';
import { required, requiredIf } from 'vuelidate/lib/validators';
import draggable from 'vuedraggable';
// Mixins
import jMixAutoScroll from '@/mixins/jMixAutoScroll';
// Components
import ColumnConfiguration from '@/views/experience-manager-v2/partials/configuration/ColumnConfiguration';

export default {
  name: 'SheetConfiguration',

  components: {
    draggable,
    ColumnConfiguration,
  },

  mixins: [jMixAutoScroll],

  props: {
    id: {
      type: String,
      default: '',
    },
    fieldDetail: {
      type: Object,
      default: () => {},
    },
    firstSheet: {
      type: Boolean,
      default: false,
    },
    variableColumns: {
      type: Array,
      default: () => [],
    },
    variableCustomColumns: {
      type: Array,
      default: () => [],
    },
    isDatasetSource: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      dataSetup: {
        sheet_name: '',
        column_source: null,
        main_columns: [],
        custom_class_columns: [],
      },
      isCustomClass: false,
      listVariable: [],
      isOpenConfigColumn: false,
      idConfigColumn: 'configurationColumn',
      selectedColumn: null,
      selectedIndexColumn: null,
    };
  },

  computed: {
    ...mapState('jStoreFormUi', ['form_data_detail']),
  },

  watch: {
    // eslint-disable-next-line func-names
    'dataSetup.sheet_name': function (val) {
      setTimeout(() => {
        this.dataSetup.sheet_name = val ? val.replace(' ', '_') : null;
      }, 1);
    },
  },

  created() {
    if (this.fieldDetail) {
      this.dataSetup = {
        sheet_name: this.fieldDetail.sheet_name,
        column_source: this.fieldDetail.column_source === '' ? null : this.fieldDetail.column_source,
        main_columns: this.fieldDetail.main_columns,
        custom_class_columns: this.fieldDetail.custom_class_columns,
      };
    }
  },

  methods: {
    setIconType(type) {
      const convertType = type.toLowerCase();
      let finalType = '';
      if (convertType === 'date' || convertType === 'mmmm dd, yyyy' || convertType === 'MMMM dd, yyyy' || convertType === 'dd-mmm-yyyy') {
        finalType = 'date';
      } else {
        finalType = convertType;
      }
      return finalType;
    },

    openConfigColumn(column, index, isCustomClass) {
      if (isCustomClass) {
        if (!this.dataSetup.column_source) {
          this.$store.dispatch('jStoreNotificationScreen/toggleInfo', 'Select column source first');
        } else {
          this.listVariable = this.variableCustomColumns.filter(option => option.id === this.dataSetup.column_source)[0].class;
          this.isCustomClass = true;
          this.selectedColumn = column;
          this.selectedIndexColumn = index;
          this.isOpenConfigColumn = true;

          this.toggleConfigurationColumn(true);
        }
      } else {
        this.isCustomClass = false;
        this.listVariable = this.variableColumns;
        this.selectedColumn = column;
        this.selectedIndexColumn = index;
        this.isOpenConfigColumn = true;

        this.toggleConfigurationColumn(true);
      }
    },

    // Open/close stacked properties
    toggleConfigurationColumn(status) {
      if (status) {
        setTimeout(() => {
          const element = document.getElementById(this.idConfigColumn);
          const elementParent = document.getElementById(this.id);
          if (element) {
            elementParent.classList.add('show-properties-group');
            element.classList.add('show-properties-field');
          }
        }, 200);
      } else {
        const element = document.getElementById(this.idConfigColumn);
        const elementParent = document.getElementById(this.id);
        if (element) {
          element.classList.remove('show-properties-field');
          elementParent.classList.remove('show-properties-group');
        }

        setTimeout(() => {
          this.isCustomClass = false;
          this.listVariable = [];
          this.selectedColumn = null;
          this.selectedIndexColumn = null;
          this.isOpenConfigColumn = false;
        }, 200);
      }
    },

    deleteColumn(index, isCustomClass) {
      this.$swal({
        title: 'Delete',
        text: 'Are you sure to delete this column?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        confirmButtonColor: '#D2232A',
        cancelButtonColor: '#D2232A',
        titleColor: '#D2232A',
      }).then(async (result) => {
        if (result.value) {
          if (isCustomClass || this.isCustomClass) {
            this.dataSetup.custom_class_columns.splice(index || this.selectedIndexColumn, 1);
          } else {
            this.dataSetup.main_columns.splice(index || this.selectedIndexColumn, 1);
          }
          this.toggleConfigurationColumn(false);
        }
      });
    },

    submitColumn(mode, params) {
      if (mode === 'add') {
        if (this.isCustomClass) {
          this.dataSetup.custom_class_columns.push(params);
        } else {
          this.dataSetup.main_columns.push(params);
        }
      } else if (mode !== 'add') {
        if (this.isCustomClass) {
          this.dataSetup.custom_class_columns[this.selectedIndexColumn] = params;
        } else {
          this.dataSetup.main_columns[this.selectedIndexColumn] = params;
        }
      }
      this.toggleConfigurationColumn(false);
    },

    deleteSheet() {
      this.$emit('delete-sheet');
    },

    closeConfiguration() {
      this.$emit('close-configuration');

      setTimeout(() => {
        this.dataSetup = {
          sheet_name: '',
          column_source: null,
          main_columns: [],
          custom_class_columns: [],
        };

        this.$v.dataSetup.$reset();
      }, 400);
    },

    submitForm() {
      this.$v.dataSetup.$touch();
      if (!this.$v.dataSetup.$error) {
        const mode = this.fieldDetail ? 'edit' : 'add';
        this.$emit('submit-configuration', mode, this.dataSetup);
      } else {
        this.scrollToErrorField('error-input');
      }
    },
  },

  validations() {
    return {
      dataSetup: {
        sheet_name: { required },
        main_columns: { required },
        column_source: {
          required: requiredIf(() => !this.firstSheet),
        },
        custom_class_columns: {
          required: requiredIf(() => !this.firstSheet),
        },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/experience-manager-v2/partials/configuration/SheetConfiguration.vue